import { IOptionItem } from "@/components/ui/dropdown/types";
import { DatasetData } from "@/types/dataset";

export type AggregationPopoverProps = {
  dataset: DatasetData;
  gridsSelected: string[];
  isOpen: boolean;
  analysisConfiguration: AnalysisConfiguration | null;
  attributesOptions?: IOptionItem[];
  filterByOptions: IOptionItem[];
  setFilterByOptions: React.Dispatch<React.SetStateAction<IOptionItem[]>>;
  setAnalysisConfiguration: (method: AnalysisConfiguration | null) => void;
  onOpenChange: (open: boolean) => void;
};

export enum TransformationMethod {
  PIVOT = "PIVOT",
  TRANSPOSE = "TRANSPOSE"
}

export enum ECategoryTransform {
  DISPLAY_ROWS_SERIES = "AGGREGATION_ALL",
  DISPLAY_ROWS_AGG = "AGGREGATION_ROW"
}

export type AnalysisConfiguration = {
  method?: IOptionItem | null;
  attribute?: IOptionItem | null;
  category?: IOptionItem | null;
  calculationMethod?: IOptionItem | null;
  filterBy?: string[] | null;
  sort?: IOptionItem | null;
  sortBy?: IOptionItem | null;
};
